/**
 * Only letters, hyphens, apostrophes and space only.
 */
export const nameRegex = new RegExp(/^[A-Za-z-'"][A-Za-z\s-'"]*$/);
export const phoneRegex = new RegExp(/^(04\d{8}|0[2378]\d{8})$/);
